import {connect} from 'react-redux';
import SEOTextComponent from './SEOText';
import {moduleLoaded, moduleHidden} from '../../reducers/moduleStatus';

export const mapDispatchToProps = {moduleLoaded, moduleHidden};

export function mapStateToProps({config: {isRefined}, content}) {
    return {
        isRefined,
        slpText: isRefined ? content.slpRefinedText : content.slpText,
    };
}

export const SEOText = connect(
    mapStateToProps,
    mapDispatchToProps
)(SEOTextComponent);

SEOText.displayName = 'SEOText';

export default SEOText;
